import { c as _c } from "react-compiler-runtime";
import { useCallback } from 'react';
import { IS_OPEN } from '../constants/CollaborationSidebarStateProperties';
export default function useSidebarOpenCloseHandlers(t0) {
  "use memo";

  const $ = _c(7);
  const {
    onUpdateCollaborationSidebarState
  } = t0;
  let t1;
  if ($[0] !== onUpdateCollaborationSidebarState) {
    t1 = () => {
      onUpdateCollaborationSidebarState({
        [IS_OPEN]: true
      });
    };
    $[0] = onUpdateCollaborationSidebarState;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onOpenSidebar = t1;
  let t2;
  if ($[2] !== onUpdateCollaborationSidebarState) {
    t2 = () => {
      onUpdateCollaborationSidebarState({
        [IS_OPEN]: false
      });
    };
    $[2] = onUpdateCollaborationSidebarState;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleClose = t2;
  let t3;
  if ($[4] !== handleClose || $[5] !== onOpenSidebar) {
    t3 = {
      handleClose,
      onOpenSidebar
    };
    $[4] = handleClose;
    $[5] = onOpenSidebar;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}